module.exports = __webpack_public_path__ + "img/writing.cf443e33.gif";